/**
 * Utilities for extracting metadata from Erdos Miller CSV file headers
 */

/**
 * Parse metadata from header lines before the CSV data
 * Handles multiple formats:
 * - "Key: Value" format
 * - "Key, Value" format (excluding headers with Time/RTC_TIME)
 * 
 * @param metadataLines Array of header lines containing metadata
 * @returns Object with metadata key-value pairs
 */
export function parseMetadata(metadataLines: string[]): Record<string, string> {
  const metadata: Record<string, string> = {};
  
  for (const line of metadataLines) {
    // Handle "Key: Value" format
    if (line.includes(':')) {
      const [key, ...valueParts] = line.split(':');
      let value = valueParts.join(':').trim();
      // Remove leading comma and space if present (e.g., "Tool Serial Number:, 966")
      if (value.startsWith(',')) {
        value = value.substring(1).trim();
      }
      if (key && value) {
        metadata[key.trim()] = value;
      }
    }
    // Handle "Key, Value" format (like in rotgamma)
    else if (line.includes(',') && !line.includes('Time') && !line.includes('RTC_TIME')) {
      const [key, value] = line.split(',');
      if (key && value) {
        metadata[key.trim()] = value.trim();
      }
    }
  }
  
  return metadata;
}